<template>
    <attribute-popover-base ref="base" :bindings="bindings" :disabled="disabled">
        <slot />
        <keen-location-picker
            slot="controls"
            v-model="internalValue" 
            :disabled="isSaving"
        />
    </attribute-popover-base>
</template>

<script>
    import AttributePopover from './AttributePopover'
    import AttributePopoverBase from './AttributePopoverBase'

    export default {
        components: { AttributePopoverBase },
        mixins: [AttributePopover],
        props: {
            label: {
                type: String,
                default: 'Location'
            }
        }
    }
</script>